import { render, staticRenderFns } from "./TableUnityManagerPending.vue?vue&type=template&id=fbb76054&"
import script from "./TableUnityManagerPending.vue?vue&type=script&lang=ts&"
export * from "./TableUnityManagerPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports